import { Route } from '@angular/router';
import { RoutingID } from '../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';
import { NetworkBookingsListComponent } from '../../../../../pages/network/network-bookings-list/network-bookings-list.component';

export const bookingsList: Route = {
  path: 'bookingsList',
  title: 'nav.network.bookingsList',
  data: {
    breadcrumb: 'nav.network.bookingsList',
    icon: SbIcons.bookingList,
    id: RoutingID.networkBookingsList,
  },
  children: [
    {
      path: '',
      component: NetworkBookingsListComponent,
      data: {
        breadcrumb: '',
      },
    },
  ],
};
